import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';
import AnimateHeight from 'react-animate-height';
import arrowIcon from '../../../../../images/icons/arrow-up.svg';
import './FreeSamples.sass';
import ClickableDiv from '../../../../ui_kit/clickable_div/ClickableDiv';
import Toggle from '../../../../ui_kit/toggle/Toggle';
import { freeSamplesActions } from '../../../actions';
import { freeSamplesObjectsSelector, freeSamplesLoadingSelector } from '../../../selectors/free_samples';
import skincareIcon from '../../../../../images/icons/skincare.svg';

class FreeSamples extends Component {
  constructor(props) {
    super(props);

    this.state = {
      expanded: true,
    };
  }

  toggle = () => {
    this.setState((prevState) => ({
      expanded: !prevState.expanded,
    }));
  };

  addFreeSample = (freeSampleId) => {
    const { addFreeSample } = this.props;
    addFreeSample(freeSampleId);
  };

  removeFreeSample = (freeSampleId) => {
    const { removeFreeSample } = this.props;
    removeFreeSample(freeSampleId);
  };

  render() {
    const {
      freeSamples, loading, uneditable, freeSamplesTitle,
    } = this.props;
    const { expanded } = this.state;

    if (!freeSamples || freeSamples.length === 0
      || (uneditable && freeSamples.filter((freeSample) => freeSample.selected).length === 0)) {
      return null;
    }

    return (
      <div className={classNames('free-samples', { active: expanded })}>
        <ClickableDiv
          className="toggle"
          onClick={this.toggle}
        >
          <div className="title">
            <img src={skincareIcon} alt="free samples" />
            {`${freeSamplesTitle} ${uneditable ? '' : '(Pick 1)'}`}
          </div>
          <div className="arrow">
            <img src={arrowIcon} alt="arrow" width="14px" />
          </div>
        </ClickableDiv>
        <AnimateHeight
          duration={400}
          height={expanded ? 'auto' : 0}
          className="products-container"
        >
          { freeSamples.filter(
            (freeSample) => (uneditable ? freeSample.selected : true),
          ).map((freeSample) => (
            <div key={freeSample.id} className={`product-container ${loading || !freeSample.eligible ? 'disabled' : ''}`}>
              <div className="product-image">
                <img src={freeSample.product.image} alt="free sample" />
              </div>
              <div className="product-content">
                <div className="product-title" dangerouslySetInnerHTML={{ __html: freeSample.product.name }} />
                <div className="product-variant">
                  {freeSample.product.variant}
                </div>
                {freeSample.rules.min_order_amount && (
                  <div className="rule">
                    *Available on orders $
                    {parseFloat(freeSample.rules.min_order_amount)}
                    {' '}
                    or more
                  </div>
                )}
              </div>
              { !uneditable && (
                <div className="toggle-wrapper">
                  <Toggle
                    className="toggle"
                    checked={freeSample.selected}
                    onChange={() => {
                      if (freeSample.selected) {
                        this.removeFreeSample(freeSample.id);
                        return;
                      }

                      this.addFreeSample(freeSample.id);
                    }}
                  />
                </div>
              )}
            </div>
          ))}
        </AnimateHeight>
      </div>
    );
  }
}

FreeSamples.propTypes = {
  freeSamples: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  addFreeSample: PropTypes.func.isRequired,
  removeFreeSample: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  uneditable: PropTypes.bool,
  freeSamplesTitle: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => ({
  freeSamples: freeSamplesObjectsSelector(state),
  loading: freeSamplesLoadingSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
  addFreeSample: (id) => dispatch(freeSamplesActions.addFreeSampleRequest({ id })),
  removeFreeSample: (id) => dispatch(freeSamplesActions.removeFreeSampleRequest({ id })),
});

export default connect(mapStateToProps, mapDispatchToProps)(FreeSamples);
